import type { PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'
import styled from 'styled-components'

import { PagingSubStore } from '../../store/subStore'

import { EmptyPage } from '../exception/EmptyPage'
import { ErrorPage } from '../exception/ErrorPage'
import type { EmptyPageProps } from '../exception/EmptyPage'
import { Spinner } from '../spinner/Spinner'
import { InfinityContent } from './InfinityContent'

type PagingContentProps = {
  emptyIcon?: EmptyPageProps['emptyIcon']
  emptyText?: string
  pagingStore: PagingSubStore<any>
  loadParam?: any
}

export const PagingContent = observer(
  ({
    children,
    pagingStore: { isFailed, isLoaded, isLoading, list, content, load, appendOffset },
    emptyIcon,
    loadParam,
    emptyText,
  }: PropsWithChildren<PagingContentProps>) => {
    let appendLoadRendering = null

    if (isLoading || !isLoaded) {
      appendLoadRendering = <Spinner />
    } else if (isFailed) {
      appendLoadRendering = <ErrorPage />
    } else if (!list.length) {
      appendLoadRendering = <EmptyPage emptyIcon={emptyIcon} content={emptyText ?? '조회 가능한 내역이 없습니다.'} />
    }

    const scroll = () => {
      appendOffset()
      load(loadParam)
    }

    return (
      <>
        <InfinityContent length={list.length} hasMore={!content?.last} onScroll={scroll}>
          {children}
        </InfinityContent>
        {appendLoadRendering ? <LoadRenderBox>{appendLoadRendering}</LoadRenderBox> : null}
      </>
    )
  },
)

const LoadRenderBox = styled.div`
  display: flex;
  flex-shrink: 1;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
`
